var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "idverify" }, [
    _c("header", { staticClass: "header" }),
    _vm._v(" "),
    _c("div", { staticClass: "body" }, [
      _c("div", { staticClass: "title" }, [_vm._v("身份确认")]),
      _vm._v(" "),
      _c("div", { staticClass: "head_img" }, [
        _c("img", { attrs: { src: _vm.result.avatarurl } })
      ]),
      _vm._v(" "),
      _vm.rangeShow
        ? _c(
            "div",
            {
              style: {
                width: _vm.mywidth + "px",
                paddingLeft: 20 + "px",
                paddingTop: 20 + "px",
                paddingBottom: 20 + "px"
              }
            },
            [
              _vm._m(0),
              _vm._v(" "),
              _vm.dialogopenV
                ? _c("slideverify", {
                    ref: "dialogopen",
                    attrs: {
                      l: 42,
                      r: 10,
                      block_y: _vm.puzzePass.block_y,
                      imgurl: _vm.puzzePass.imgurl,
                      miniimgurl: _vm.puzzePass.miniimgurl,
                      "slider-text": _vm.puzzePass.text
                    },
                    on: {
                      success: _vm.onSuccess,
                      fail: _vm.onFail,
                      refresh: _vm.onRefresh
                    }
                  })
                : _vm._e()
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.faceShow,
              expression: "faceShow"
            }
          ]
        },
        [
          _c("div", { staticClass: "text" }, [
            _c("p", [
              _vm._v(
                "按照当地政策要求,学员在学习过程中需按照规定进行人脸识别与学员照片进行比对，待身份鉴定通过后方可继续。"
              )
            ]),
            _vm._v(" "),
            _c("p", [
              _vm._v("请确保设备的摄像头连接正常，并点击下面按钮开始。")
            ]),
            _vm._v(" "),
            _vm.superrMsg
              ? _c("p", [
                  _vm._v(
                    "请在" +
                      _vm._s(_vm.limitLearningBySuperTimeOut) +
                      "秒内完成人脸识别"
                  )
                ])
              : _vm._e()
          ]),
          _vm._v(" "),
          !_vm.uploading
            ? _c(
                "a",
                {
                  ref: "onf",
                  staticClass:
                    "mint-button mint-button--default mint-button--large is-plain",
                  staticStyle: {
                    "background-color": "#1f88f2",
                    "padding-top": "10px"
                  },
                  attrs: { href: "javascript:void(0);" },
                  on: { click: _vm.uploadPhoto }
                },
                [_vm._v("开始")]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.uploading
            ? _c(
                "mt-button",
                { staticClass: "button", attrs: { type: "primary" } },
                [_vm._v("上传识别中……")]
              )
            : _vm._e()
        ],
        1
      )
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "text1" }, [
      _c("p", [
        _vm._v(
          "请滑动滑块验证，验证通过后进行人脸识别与学员照片进行比对，待身份鉴定通过后方可继续。"
        )
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-afaa55b8", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-afaa55b8","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/idverify4Unit.vue
// module id = null
// module chunks = 